import { Text } from '@chakra-ui/react';
import { RichTextChunk } from '@texas/api/endpoints/chat/richTextTypes';
import { EntityValueDesign } from './renders/EntityValue';
import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';
import { compareEnum } from '@texas/utils/helpers/enumHelpers';
import { AngularNavLink } from '../shared/AngularNavLink';
import { Icons } from '../shared/Icons';

export function UserChatMessageChunkRenderer(props: {
  chunks: RichTextChunk[];
}) {
  return (
    <>
      {props.chunks.map((x, i) => {
        switch (x.type) {
          case 'paragraph':
            return (
              <Text as="span" key={i}>
                {x.text}
                <UserChatMessageChunkRenderer chunks={x.children} />
              </Text>
            );
          case 'entity-value':
            return (
              <EntityValueDesign key={i} type={x.entityType} id={x.entityId}>
                <EntityTypeFunction id={x.entityId} type={x.entityType}>
                  {x.label}
                </EntityTypeFunction>
                <UserChatMessageChunkRenderer chunks={x.children} />
              </EntityValueDesign>
            );
        }
      })}
    </>
  );
}

function EntityTypeFunction({
  id,
  type,
  children,
}: {
  id: number;
  type: ChatMessageEntityLinkType;
  children: React.ReactNode;
}) {
  if (
    compareEnum(
      ChatMessageEntityLinkType,
      type,
      ChatMessageEntityLinkType.Customer,
    )
  ) {
    return (
      <AngularNavLink
        to="customer"
        navobj={{
          customerId: id,
        }}
      >
        {children}
        <Icons.OpenInNew pl={1} />
      </AngularNavLink>
    );
  }

  return <>{children}</>;
}
